import React, { useState } from 'react';
import CloseIcon from '../../../../assets/icons/close.svg';
import { AuthenticatedPUTRequest, hasNull } from '../../../../utils';
import { departments } from '../../../../constants/constants';
import { isEmptyObject } from '../../../../utils';

const EditTeacherEducationalInfoModal = (props) => {
    const { id, teacher, onError, onClose } = props;
    const [educationInformation, setEducationInformation] = useState({
        islamic_education: teacher.islamic_education,
        regular_education: teacher.regular_education,
        awards: teacher.awards,
        writers_of: teacher.writers_of,
        department_of_teaching: teacher.department_of_teaching,
        other_services: teacher.other_services,
        degree_completion: teacher.degree_completion,
        beginning_of_teaching: teacher.beginning_of_teaching,
        beginning_of_teaching_in_jamia_nizamia_rizvia:
            teacher.beginning_of_teaching_in_jamia_nizamia_rizvia,
    });
    const [loading, setLoading] = useState(false);
    const updateTeacherEducation = async (values) => {
        setLoading(true);
        try {
            const { success } = await AuthenticatedPUTRequest(`teachers/${id}`, {
                teacher: values,
            });

            if (!success) {
                onError('براہ کرم دوبارہ کوشش کریں۔');
                setLoading(false);
                onClose();
            } else {
                window.location.reload();
                setLoading(false);
                onClose();
            }
        } catch (error) {
            setLoading(false);
            onError('براہ کرم دوبارہ کوشش کریں۔');
            onClose();
        }
    };

    const onSubmit = () => {
        const isSuccess = hasNull(educationInformation);
        if (isSuccess) {
            onError('براےٗ مہربانی تعلیمی معلومات مکمل درج کریں');
        } else {
            var updatedInformation = {};
            for (let key in educationInformation) {
                if (educationInformation[key] !== teacher[key]) {
                    updatedInformation[key] = educationInformation[key];
                }
            }
            if (!isEmptyObject(updatedInformation)) {
                updateTeacherEducation(updatedInformation);
            } else {
                onClose();
            }
        }
    };

    return (
        <div
            className='flex column justifyCenter alignCenter'
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 1000,
                background: 'rgba(0,0,0,0.7)',
            }}
        >
            <div
                style={{
                    background: '#ffffff',
                    height: 520,
                    maxHeight: 520,
                    width: 980,
                    borderRadius: 8,
                }}
            >
                <div className='h-100 w-100' style={{ overflow: 'auto', position: 'relative' }}>
                    <div
                        className='flex justifyBetween alignCenter w-100'
                        style={{
                            borderBottom: '1px solid #E0E0E0',
                            padding: '20px 16px 8px',
                            height: 72,
                        }}
                    >
                        <h2 className='flex alignCenter w-100' style={{ color: '#009688' }}>
                            تعلیمی معلومات کے ریکارڈ میں ترمیم کریں
                        </h2>

                        <img
                            src={CloseIcon}
                            alt='close_icon'
                            height={32}
                            width={32}
                            onClick={props.onClose}
                            style={{ cursor: 'pointer' }}
                        />
                    </div>

                    <div className='flex justifyBetween alignCenter' style={{ padding: '0 20px' }}>
                        {/* present islamic education */}
                        <div className='form-container urdu'>
                            <label htmlFor='islamic_education'>
                                تعلیمی قابلیت دینی
                                <span className='mlr required'>*</span>
                            </label>
                            <input
                                type='text'
                                name='islamic_education'
                                value={educationInformation['islamic_education']}
                                onChange={(e) => {
                                    if (e.target.value.length > 0) {
                                        setEducationInformation({
                                            ...educationInformation,
                                            islamic_education: e.target.value,
                                        });
                                    } else {
                                        setEducationInformation({
                                            ...educationInformation,
                                            islamic_education: '',
                                        });
                                    }
                                }}
                            />
                        </div>
                        {/* present regular education */}
                        <div className='form-container urdu'>
                            <label htmlFor='regular_education'>
                                تعلیمی قابلیت عصری
                                <span className='mlr required'>*</span>
                            </label>
                            <input
                                type='text'
                                name='regular_education'
                                value={educationInformation['regular_education']}
                                onChange={(e) => {
                                    if (e.target.value.length > 0) {
                                        setEducationInformation({
                                            ...educationInformation,
                                            regular_education: e.target.value,
                                        });
                                    } else {
                                        setEducationInformation({
                                            ...educationInformation,
                                            regular_education: '',
                                        });
                                    }
                                }}
                            />
                        </div>
                        {/* awards */}
                        <div className='form-container urdu'>
                            <label htmlFor='awards'>
                                اعزازات
                                <span className='mlr required'>*</span>
                            </label>
                            <input
                                type='text'
                                name='awards'
                                value={educationInformation['awards']}
                                onChange={(e) => {
                                    if (e.target.value.length > 0) {
                                        setEducationInformation({
                                            ...educationInformation,
                                            awards: e.target.value,
                                        });
                                    } else {
                                        setEducationInformation({
                                            ...educationInformation,
                                            awards: '',
                                        });
                                    }
                                }}
                            />
                        </div>
                    </div>

                    <div className='flex justifyBetween alignCenter' style={{ padding: 20 }}>
                        {/* writers of */}
                        <div className='form-container urdu'>
                            <label htmlFor='writers_of'>
                                تصانیف
                                <span className='mlr required'>*</span>
                            </label>
                            <input
                                type='text'
                                name='writers_of'
                                value={educationInformation['writers_of']}
                                onChange={(e) => {
                                    if (e.target.value.length > 0) {
                                        setEducationInformation({
                                            ...educationInformation,
                                            writers_of: e.target.value,
                                        });
                                    } else {
                                        setEducationInformation({
                                            ...educationInformation,
                                            writers_of: '',
                                        });
                                    }
                                }}
                            />
                        </div>
                        {/*  department_of_teaching  */}
                        <div className='form-container urdu'>
                            <label htmlFor='department_of_teaching'>
                                شعبہ تدریس
                                <span className='mlr required'>*</span>
                            </label>
                            <select
                                name='department_of_teaching'
                                onChange={(e) => {
                                    if (e.target.value.length > 0) {
                                        setEducationInformation({
                                            ...educationInformation,
                                            department_of_teaching: e.target.value,
                                        });
                                    } else {
                                        setEducationInformation({
                                            ...educationInformation,
                                            department_of_teaching: '',
                                        });
                                    }
                                }}
                            >
                                <option value='none'>اپنا شعبہ تدریس منتخب کریں</option>
                                {departments.map((degree, index) => (
                                    <option value={degree} key={index + 1}>
                                        {degree}
                                    </option>
                                ))}
                            </select>
                        </div>
                        {/* other services */}
                        <div className='form-container urdu'>
                            <label htmlFor='other_services'>
                                دیگر خدمات
                                <span className='mlr required'>*</span>
                            </label>
                            <input
                                type='text'
                                name='other_services'
                                value={educationInformation['other_services']}
                                onChange={(e) => {
                                    if (e.target.value.length > 0) {
                                        setEducationInformation({
                                            ...educationInformation,
                                            other_services: e.target.value,
                                        });
                                    } else {
                                        setEducationInformation({
                                            ...educationInformation,
                                            other_services: '',
                                        });
                                    }
                                }}
                            />
                        </div>
                    </div>

                    <div className='flex justifyBetween alignCenter' style={{ padding: '0 20px' }}>
                        {/* date of degree completion */}
                        <div className='form-container urdu'>
                            <label htmlFor='permanentProvince'>
                                سن فراغت
                                <span className='mlr required'>*</span>
                            </label>
                            <input
                                type='date'
                                style={{ fontFamily: 'CircularStd' }}
                                name='degree_completion'
                                value={educationInformation['degree_completion']}
                                onChange={(e) => {
                                    if (e.target.value.length > 0) {
                                        setEducationInformation({
                                            ...educationInformation,
                                            degree_completion: e.target.value,
                                        });
                                    } else {
                                        setEducationInformation({
                                            ...educationInformation,
                                            degree_completion: '',
                                        });
                                    }
                                }}
                            />
                        </div>
                        {/* date of start teaching career */}
                        <div className='form-container urdu'>
                            <label htmlFor='beginning_of_teaching'>
                                آغاز تدریس
                                <span className='mlr required'>*</span>
                            </label>
                            <input
                                type='date'
                                style={{ fontFamily: 'CircularStd' }}
                                name='beginning_of_teaching'
                                value={educationInformation['beginning_of_teaching']}
                                onChange={(e) => {
                                    if (e.target.value.length > 0) {
                                        setEducationInformation({
                                            ...educationInformation,
                                            beginning_of_teaching: e.target.value,
                                        });
                                    } else {
                                        setEducationInformation({
                                            ...educationInformation,
                                            beginning_of_teaching: '',
                                        });
                                    }
                                }}
                            />
                        </div>
                        {/* date of start teaching career in jamia nizamia rizvia institue */}
                        <div className='form-container urdu'>
                            <label htmlFor='permanentProvince'>
                                جامعہ نظامیہ رضویہ میں آغاز تدریس
                                <span className='mlr required'>*</span>
                            </label>
                            <input
                                type='date'
                                style={{ fontFamily: 'CircularStd' }}
                                name='beginning_of_teaching_in_jamia_nizamia_rizvia'
                                value={
                                    educationInformation[
                                        'beginning_of_teaching_in_jamia_nizamia_rizvia'
                                    ]
                                }
                                onChange={(e) => {
                                    if (e.target.value.length > 0) {
                                        setEducationInformation({
                                            ...educationInformation,
                                            beginning_of_teaching_in_jamia_nizamia_rizvia:
                                                e.target.value,
                                        });
                                    } else {
                                        setEducationInformation({
                                            ...educationInformation,
                                            beginning_of_teaching_in_jamia_nizamia_rizvia: '',
                                        });
                                    }
                                }}
                            />
                        </div>
                    </div>
                    <div
                        className='flex justifyEnd alignCenter w-100'
                        style={{ height: 64, paddingLeft: 16, marginTop: 16 }}
                    >
                        <div className='flex justifyBetween alignCenter'>
                            <div
                                className='flex justifyEnd alignCenter register_button'
                                style={{ margin: '0 8px' }}
                                onClick={() => onSubmit()}
                            >
                                {loading ? (
                                    <div className='custom_loader' />
                                ) : (
                                    <h3>{`محفوظ کریں`}</h3>
                                )}
                            </div>
                            <div
                                className='flex justifyEnd alignCenter delete_button'
                                style={{ margin: '0 8px' }}
                                onClick={props.onClose}
                            >
                                <h3>{`منسوخ کریں`}</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditTeacherEducationalInfoModal;
